import React from 'react';

class BarAppearance extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'BarAppearance';
    this.state = {
      data: this.props.barData,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.barData) {
      this.setState({
        data: nextProps.barData,
      });
    }
  }
  handleChange(key, event) {
    const data = this.state.data ? this.state.data : {};
    data[key] = event.target.value;
    this.props.appearData(data);
    this.setState({ data });
  }
  render() {
    const dummy = {
      filter_count: '',
      sorting_option: '',
      view_changer: '',
      topbar_pagination: '',
      bottombar_loadmore: '',
      bottombar_pagination: '',
    };

    const data = this.state.data ? this.state.data : dummy;
    return (<div role="tabpanel" className="tab-pane" id="barapp">
      <div className="flex-row">
        <div className="flex-sm-6 flex-xs-12">
          <input type="text" value={data.filter_count} className="reactive-input" onChange={this.handleChange.bind(this, 'filter_count')} placeholder={API.LANG.PLACE_CLASS_NAME_4_FILTER_COUNT}/>
        </div>
        <div className="flex-sm-6 flex-xs-12">
          <input type="text" value={data.sorting_option} className="reactive-input" onChange={this.handleChange.bind(this, 'sorting_option')} placeholder={API.LANG.PLACE_CLASS_NAME_4_SORT}/>
        </div>
        <div className="flex-sm-6 flex-xs-12">
          <input type="text" value={data.view_changer} className="reactive-input" onChange={this.handleChange.bind(this, 'view_changer')} placeholder={API.LANG.PLACE_CLASS_NAME_4_VIEW}/>
        </div>
        <div className="flex-sm-6 flex-xs-12">
          <input type="text" value={data.topbar_pagination} className="reactive-input" onChange={this.handleChange.bind(this, 'topbar_pagination')} placeholder={API.LANG.PLACE_CLASS_NAME_4_TOP_PAGINATION}/>
        </div>
        <div className="flex-sm-6 flex-xs-12">
          <input type="text" value={data.bottombar_pagination} className="reactive-input" onChange={this.handleChange.bind(this, 'bottombar_pagination')} placeholder={API.LANG.PLACE_CLASS_NAME_4_BOTTOM_PAGINATION}/>
        </div>
        <div className="flex-sm-6 flex-xs-12">
          <input type="text" value={data.bottombar_loadmore} className="reactive-input" onChange={this.handleChange.bind(this, 'bottombar_loadmore')} placeholder={API.LANG.PLACE_CLASS_NAME_4_BOTTOM_LOAD_MORE}/>
        </div>
      </div>
    </div>);
  }
}

export default BarAppearance;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/barpanel.js